import { ColumnOrMetricName, getDataColForMetadata } from "@blisspointmedia/bpm-types/dist/Columns";
import { GlossaryItem } from "../../Components/GlossaryModal/GlossaryModal";
import { App2Channels } from "@blisspointmedia/bpm-types/dist/ScpChannels";

export const GLOSSARY_MAP: Partial<Record<ColumnOrMetricName, GlossaryItem>> = {
  revenue: {
    term: "KPI Revenue",
    definition:
      "The number of dollars generated in return. Typically commerce uses 14d attribution for attributing revenue to an ad.",
  },
  clicksConversionRate: {
    term: "Clicks Conversion Rate",
    definition: "Conversion Rate = KPI volume / clicks",
  },
  impsConversionRate: {
    term: "Impressions Conversion Rate",
    definition: "Conversion Rate = KPI volume / impressions",
  },
  roas: {
    term: "ROAS",
    definition: "Return on Ad Spend = revenue / spend",
  },
  spend: {
    term: "Spend",
    definition: "The number of dollars invested.",
  },
  impressions: {
    term: "Impressions",
    definition: "The number of times the ad(s) are delivered.",
  },
  clicks: {
    term: "Clicks",
    definition: "The number of times the ad is clicked.",
  },
  cpm: {
    term: "CPM",
    definition: "Cost per thousand impressions = (spend x 1,000) / impressions",
  },
  cpc: {
    term: "CPC",
    definition: "Cost per Click = spend / clicks",
  },
  ctr: {
    term: "Clicks and Click-through rate (CTR)",
    definition: `Clicks and Click-through rate (CTR): Clicks, which occur when the viewer clicks an interactive element of your ad, and CTR (Clicks / Impressions) for Video campaigns shouldn’t typically be considered a priority compared to impressions or views (if your goal is awareness) or conversions (if your goal is sales). Low clicks and CTR, is fairly normal in Video campaigns, compared to Search campaigns.
    Clicks and CTR within Video campaigns are typically not metrics that you should have as a priority to determine campaign success. It can be an indicator of how well your ad prompts users to take action upon viewing your ads, but the primary metric with which conversions are given attribution to your Video campaigns is "views" (for example, a click is not required for your campaign to get credit for a conversion, but a view is).`,
  },
  // TODO These haven't been added as column / metrics yet
  // orders: {
  //   term: "Orders",
  //   definition:
  //     "The number of unique orders contributed to the ad on the platform it is served on. In general, we default to using 14 day attribution across the board but it is possible for some to have custom setups.",
  // },
  // units: {
  //   term: "Units",
  //   definition:
  //     "The number of units purchased in the orders contributed to the ad. This should always be equal to or greater than the number of orders.",
  // },
  // acos: {
  //   term: "ACOS",
  //   definition:
  //     "Advertising Cost of Sales. This is the inverse of ROAS and aims to show how much you need to spend in order to generate one dollar of revenue. Formula is spend/revenue. Anything under 1 means that you are generating more revenue than you are spending.",
  // },
  // ntbOrders:{
  //   term: "NTB Orders",
  //   definition:
  //     "New to Brand Orders. The amount of orders that were attributed to your ad where the consumer has not purchased from that brand within the past year.",
  // },
  // ntbSales: {
  //   term: "NTB Sales",
  //   definition:
  //     "New to Brand Sales. The amount of sales revenue generated by the New to Brand Orders.",
  // },
  // conversions: {
  //   term: "Conversions",
  //   definition:
  //     "In Video campaigns, conversions are measured when a viewer is counted as a view for your ad and then takes an action that you’ve defined as valuable to your business, such as an online purchase or a call to your business from a mobile phone.",
  // },
  // cvr: {
  //   term: "Conversions Rate",
  //   definition: `Conversion rate (CVR): CVR gives insight into how effective your ad is at getting users to your site and converting after being counted as a view. Like many of the other metrics, a good CVR is very dependent on the advertiser industry.
  // CVR = Conversions / Views`,
  // },
};

export const getChannelGlossary = (channel: App2Channels): Array<GlossaryItem> => {
  const glossary: Array<GlossaryItem> = [];
  getDataColForMetadata(channel).forEach(col => {
    if (GLOSSARY_MAP[col.name]) {
      glossary.push(GLOSSARY_MAP[col.name]);
    }
  });
  return glossary.sort();
};
